import clearGravityWebsiteHandoff from './clearGravityWebsiteHandoff.js';
import deliverGravityWebsiteHandoff from './deliverGravityWebsiteHandoff.js';
import readGravityWebsiteHandoff from './readGravityWebsiteHandoff.js';
import shouldClearGravityWebsiteHandoff from './shouldClearGravityWebsiteHandoff.js';

const DELIVERY_WAIT_MS = 7_000;

const deliverGravityWebsiteHandoffBeforeNavigation = async ({ handoffId } = {}) => {
  const savedAt = readGravityWebsiteHandoff()?.savedAt || Date.now();
  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = window.setTimeout(() => {
      resolve({
        success: false,
        code: 'GRAVITY_WEBSITE_HANDOFF_DELIVERY_TIMEOUT'
      });
    }, DELIVERY_WAIT_MS);
  });
  const result = await Promise.race([
    deliverGravityWebsiteHandoff({
      handoffId
    }),
    timeout
  ]);

  window.clearTimeout(timeoutId);

  if (shouldClearGravityWebsiteHandoff({ result, savedAt })) {
    clearGravityWebsiteHandoff(handoffId);
  }

  return result;
};

export default deliverGravityWebsiteHandoffBeforeNavigation;
